<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script lang="ts">
import {addDnsPrefetch} from "@/helpers/prefetchHelper";
import {defineComponent} from "vue";

export default defineComponent({
  name: "App",
  setup() {
    addDnsPrefetch()

    return {};
  },
});
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap");
@import "@/assets/scss/global.scss";

#app {
  background-color: white;
  font-family: "Inter", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}

:root {
  --Alerts-Success-Success-Background: #e6f4ea;
  --Gray-elements-Background-BLOCKS: #fbfbfb;
  --Gray-elements-Border-1-inactive-botton: #ddd;
  --Gray-elements-Segmenter-lines: #f2f2f2;
  --main-white: #fff;
  --Primary-Green-1: #2c7040;
  --text-grey: #888;
  --Typography-Text-1: #111;
  --Typography-Text-2: #666;
}

a {
  color: var(--Primary-Green-1);
}
</style>
